<template>
  <div class="objection-page">
    <site-header />
    <page-banner
      :src="banner.src"
      :alt="banner.alt"
      :fill-left="banner.fillLeft"
      :fill-right="banner.fillRight"
      auto-height
    />
    <main class="objection-page__main">
      <div class="core-container">
        <register-page-content :sections="sections" />
      </div>
    </main>
    <site-footer />
  </div>
</template>

<script>
import SiteHeader from '@/components/home/SiteHeader.vue'
import SiteFooter from '@/components/home/SiteFooter.vue'
import PageBanner from '@/components/common/PageBanner.vue'
import RegisterPageContent from '@/components/register/RegisterPageContent.vue'
import {
  OBJECTION_BANNER,
  OBJECTION_PAGE_SECTIONS
} from '@/constants/objectionPage'

export default {
  name: 'TrademarkObjectionPage',
  components: {
    SiteHeader,
    SiteFooter,
    PageBanner,
    RegisterPageContent
  },
  data() {
    return {
      banner: OBJECTION_BANNER,
      sections: OBJECTION_PAGE_SECTIONS
    }
  }
}
</script>

<style scoped>
.objection-page {
  min-height: 100vh;
  background: var(--color-bg-main);
}

.objection-page__main {
  padding-bottom: var(--space-xl);
}
</style>
